import { smoothScroll, smoothScrollElem } from "//www.cluedupp.com/cdn/shop/t/122/assets/utils.js?v=6930671329281742791710339512";

export default function init() {
  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach((element) => {
    element.addEventListener(
      "click",
      function (event) {
        let hash = this.getAttribute("href");

        if (!hash.includes("smile-")) {
          event.preventDefault();
          smoothScroll(hash);
        }
      },
      false
    );
  });

  const reviewsWidgets = document.querySelectorAll(
    "[data-oke-reviews-product-listing-rating]"
  );

  if (!reviewsWidgets) return;

  reviewsWidgets.forEach((widget) => {
    widget.addEventListener("click", function () {
      const target = document.querySelector("[data-oke-reviews-carousel]");

      smoothScrollElem(target);
    });
  });
}
